import React from 'react';

const Image = ({ src, className, ...imgProps }) => {
  return (
    <div className={className}>
      <img className="w-full h-full" {...imgProps} src={src} />
    </div>
  );
};

export default Image;
